export default "__VITE_ASSET__Z2H$mWr8__"